<template>
  <div>
    <profile-reviews-empty-state
      v-if="!reviews.length"
      :profileAccountData="profileAccountData"
      :profileBelongsToViewer="profileBelongsToViewer"
    />
    <div v-else>
      <!-- TODO: add rating distribution component -->
      <reviews-list
        :reviews="reviews"
        :totalReviewCount="totalReviewCount"
        :showReplies="true"
        :revieweeDisplayName="profileAccountData.displayName"
        :isOwner="profileBelongsToViewer"
        :fullWidthBtn="true"
        @view-more-reviews="$emit('view-more-reviews')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import ProfileReviewsEmptyState from './ProfileReviewsEmptyState.vue';
import ReviewsList from '@/components/reviews_list/ReviewsList.vue';

interface Review {
  node: {
    reviewerShortName: string;
    stars: string;
    at: string;
    publicFeedback: string;
  };
}

export default {
  name: 'ProfileReviews',
  components: {
    ProfileReviewsEmptyState,
    ReviewsList,
  },
  props: {
    reviewsData: {
      type: Object,
      default: () => ({}),
    },
    profileAccountData: {
      type: Object,
      default: () => ({}),
    },
    profileBelongsToViewer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reviews(): Array<Review> {
      return this.reviewsData?.edges || [];
    },
    totalReviewCount(): number {
      return this.reviewsData?.totalReviewCount || 0;
    },
  },
};
</script>
